import { CutomerService } from './../../service/cutomerService/cutomer.service';
import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-view-profile',
  templateUrl: './view-profile.component.html',
  styleUrls: ['./view-profile.component.scss']
})
export class ViewProfileComponent implements OnInit {
editId:any;
user:any;
  constructor(private activeRoute:ActivatedRoute,private customerService:CutomerService) { 
    this.editId=this.activeRoute.snapshot.paramMap.get('id');
    this.user={
      image:{url:''}
    }
    this.getCutomerDetails();
  }
  getCutomerDetails()
  {
    this.customerService.getCustomersDetail(this.editId).then((res)=>
    {
      this.user=res
      console.log(this.user)
    })
  }

  ngOnInit(): void {
  }

}
